/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface SetTenderItemBid$Params {
  tenderId: string;
  itemId: string;
      body: number
}

export function setTenderItemBid(http: HttpClient, rootUrl: string, params: SetTenderItemBid$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, setTenderItemBid.PATH, 'put');
  if (params) {
    rb.path('tenderId', params.tenderId, {});
    rb.path('itemId', params.itemId, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

setTenderItemBid.PATH = '/tenders/{tenderId}/items/{itemId}/price';
